<script>
  import { layoutMethods, billsPaymentMethods} from "@/state/helpers";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
//   import Swal from 'sweetalert2';

  /**
   * Logs
   */
  export default {
    props:{
      biller: Object
    },  
    page: {
      title: "Logs"
    },
    components: {
      flatPickr
    },
    computed: {
    },
    data() {
      return {
        title: "Logs",
        searchValue: {
          page: 1,
          rows: 10,
          dateRange:null
        },
        rangeOptions: {
          mode: "range",
        },
        fields: [
          {key: "modifiedBy", sortable: false, label: 'Modified By'},
          {key: "modifiedAt", sortable: false, label: 'Modified date & time'},
          {key: "status", sortable: true, label: 'Status'}
        ] ,
        tableData: [],
        tableTotal: 0,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      }
    },
    methods: {
      ...layoutMethods,
      ...billsPaymentMethods,
        async openModal(modal=''){
            this.$bvModal.show(modal);
            await this.onSearch("reset");
        },
        closeModal(modal=''){
            this.$bvModal.hide(modal);
        },
        async onSearch(state = ''){
            if(state == 'reset'){
              this.searchValue.page = 1;
            }
            console.log(":: searchValue ::",JSON.stringify(this.searchValue));
            await this.actionBillsPayment({
                action: "activity-logs",
                body: {billerCode : this.biller.billerCode,...this.searchValue}
            })
            .then((res) => {
              console.log(res);
              this.tableData = res?.message?.rows??[]
              this.tableTotal= res?.message?.pageInfo?.total??0
            })
            .catch((e)=>{
              console.log(e);
              this.tableData = [];
              this.tableTotal= 0
            });
        }
    },
    async mounted(){
    }
  }
</script>



<template>
    <div><!-- outer div-->
        <div class="d-flex align-items-center">
            <div class="flex-grow-1 row">
                <p class="mb-1 font-size-13 col-6 fw-bold">Activity log:</p>
                <div class="mb-1 col-6 text-end">
                    <b-link class="small fw-semibold text-primary" @click="openModal('bv-modal-billspayment-logs')">View</b-link>
                </div>
            </div>
        </div>



        <b-modal id="bv-modal-billspayment-logs"
        size="lg"
        centered
        hide-header
        hide-footer
        >
            <div class="row">
                <!-- {{ biller.billerCode }} -->
                <span></span>
                <h5 class="fw-semibold text-black my-3 col-12">Activity Log: {{ tableTotal }} Record(s)</h5>
                <div class="col-12 d-flex flex-wrap mt-3 mb-2 px-3">
                  <div class="me-2 ta-right"><!--filter by date modified-->
                    <b-form-group description="Filter by date modified">
                        <flat-pickr
                          v-model="searchValue.dateRange"
                          placeholder="Filter by date modified"
                          class="form-control"
                          style="width: 250px;"
                          :config="rangeOptions"
                        ></flat-pickr>
                    </b-form-group>
                  </div><!--filter date modified-->

                  <div class="me-2">
                    <a class="btn btn-primary h-fit" @click="onSearch('reset')">
                      <i class='bx bx-search bx-fw'></i>Search
                    </a>
                  </div>
                </div>
                <div class="col-12">
                    <b-table
                        :items="tableData"
                        :fields="fields"
                        responsive="sm"
                        :current-page="searchValue.page"
                        class="table-check"
                        >

                        <template #cell(modifiedAt)="data">
                            {{ data.item.modifiedAt |  formatDateNoComma}}
                        </template>
                    </b-table>
                    <div class="row g-0 text-center" v-if="tableTotal == 0">
                        <span>No data to display.</span>
                    </div>
                    <div class="row g-0 text-center text-sm-start" v-if="tableTotal != 0 && tableTotal > 10">
                    <!-- end col -->
                    <div class="col-sm-12">
                        <div class="row">
                        <div class="col">
                            <div
                            class="dataTables_paginate paging_simple_numbers float-end" 
                            >
                            <!-- pagination -->
                            <b-pagination
                                class="pagination-rounded"
                                v-model="searchValue.page"
                                :total-rows="tableTotal"
                                :per-page="searchValue.rows"
                                @input="onSearch"
                            ></b-pagination>
                            </div>
                        </div>
                        </div>
                    </div>
                    <!-- end col -->
                    </div>
                </div>
            </div>
        </b-modal>
    </div> <!-- end of outer div-->
</template>

<style scope>
</style>